/**
 * WbListRow — rij-knop 64 px, het lijst-item van alle lijstpagina's.
 *
 * Slots: `links` (thumbnail of vinkje), `hoofd` (mono nummer of naam),
 * `chips` naast de hoofdregel, `sub` (mono subregel), `rechts` (vervangt de
 * chevron, bv. een Foto-knop). Zonder onClick is het een <div> (geen knop).
 */

import clsx from 'clsx';

export interface WbListRowProps {
  hoofd: React.ReactNode;
  sub?: React.ReactNode;
  chips?: React.ReactNode;
  links?: React.ReactNode;
  rechts?: React.ReactNode;
  onClick?: () => void;
  /** Hoofdregel niet mono (namen, straten). */
  tekst?: boolean;
  /** Geselecteerd / afgevinkt: groene vulling (klaar-semantiek). */
  klaar?: boolean;
  /** Mint rand: dit is de actuele rij. */
  isNu?: boolean;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function WbListRow({ hoofd, sub, chips, links, rechts, onClick, tekst = false, klaar = false, isNu = false, disabled, className, ...aria }: WbListRowProps) {
  const inhoud = (
    <>
      {links && <div className="shrink-0 flex items-center">{links}</div>}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={clsx('font-semibold text-wb-inkt', tekst ? 'font-wb-heading text-lg leading-tight' : 'font-mono text-lg')}>{hoofd}</span>
          {chips}
        </div>
        {sub && <div className="font-mono text-sm text-wb-inkt2 truncate">{sub}</div>}
      </div>
      {rechts !== undefined ? (
        <div className="shrink-0 flex items-center" onClick={(e) => e.stopPropagation()}>{rechts}</div>
      ) : onClick ? (
        <svg className="w-5 h-5 shrink-0 text-wb-inkt" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      ) : null}
    </>
  );
  const klassen = clsx(
    'w-full min-h-[64px] flex items-center gap-3 px-3 py-2 border-wb rounded-wb text-left',
    klaar ? 'bg-wb-afleveren border-wb-rand' : 'bg-wb-vlak',
    !klaar && (isNu ? 'border-wb-mint' : 'border-wb-rand'),
    disabled && 'opacity-40',
    className
  );
  if (onClick) {
    return (
      <button type="button" onClick={onClick} disabled={disabled} className={clsx(klassen, 'wb-focus select-none active:bg-wb-gedempt')} {...aria}>
        {inhoud}
      </button>
    );
  }
  return <div className={klassen} {...aria}>{inhoud}</div>;
}
